import React, { FC, useCallback, useEffect, useMemo } from "react";
import { debounce } from "@evergis/sgis/es/utils/utils";
import { useTranslation } from "react-i18next";

import { getFilter } from "ducks/catalog/selectors";
import { setFilter } from "ducks/catalog/catalog";
import { useFilter } from "../../hooks/useFilter";
import { useFilterState } from "../../hooks/useFilterState";
import { SearchField, SearchFieldContainer } from "./styled";

import { SearchProps } from "./types";

const DEBOUNCE_DELAY = 500;

export const Search: FC<SearchProps> = ({ maxWidth, minWidth, width }) => {
  const { t } = useTranslation("common");
  const [filter, updateFilter] = useFilter(getFilter, setFilter);
  const [searchFilter, updateFilterState] = useFilterState(filter);
  const debouncedSetFilter = useMemo(() => debounce(updateFilter, DEBOUNCE_DELAY), [updateFilter]);
  const setInput = useCallback(value => updateFilterState(value), [updateFilterState]);
  const changeInput = useCallback(event => setInput(event.target.value), [setInput]);
  const eraseInput = useCallback(() => setInput(""), [setInput]);
  const searchRequest = useCallback(() => updateFilter(searchFilter), [searchFilter, updateFilter]);

  useEffect(() => {
    debouncedSetFilter(searchFilter);
  }, [debouncedSetFilter, searchFilter]);

  return (
    <SearchFieldContainer maxWidth={maxWidth} minWidth={minWidth} width={width}>
      <SearchField
        onEraseClick={eraseInput}
        id={"projectsSearch"}
        onChange={changeInput}
        onSearchRequest={searchRequest}
        value={searchFilter}
        width={"100%"}
        maxWidth={maxWidth}
        minWidth={minWidth}
        placeholder={t("search")}
      />
    </SearchFieldContainer>
  );
};
